<template>
  <div class="main-chapter1">
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 14
    </div>
    <div class="chapter-title">Общие сведения</div>
    <n-items v-if="project">
      <n-input title="Строительная организация" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Строительство" v-bind="$form.input('building')" :text="!editable" />
      <n-input title="Старший производитель работ, ответственный за объект" v-bind="$form.input('responsibleWork')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
